
import { defineComponent } from 'vue';
import { InputValidator } from '@/utils';
import Input from '@/components/atoms/Input.vue';
import Button from '@/components/atoms/Button.vue';
import Message from '@/components/atoms/Message.vue';
import Logo from '@/components/atoms/Logo.vue';
import IconArrowLeft from '@/components/atoms/IconArrowLeft.vue';
import { forgotPassword } from '@/service/cognitoService';
import { mapActions, mapGetters } from 'vuex';
import { AppStatus } from '@/model/status';
import { AlertMessage, MessageType } from '@/model/message';
import { CognitoException } from '@/model/cognito';

export default defineComponent({
  name: 'ForgotPassword',
  components: {
    Input,
    Button,
    Message,
    IconArrowLeft,
    Logo
  },
  data () {
    return {
      email: '' as string,
      message: {} as AlertMessage,
      forgotPasswordSuccess: false
    };
  },
  mounted () {
    if (this.myEmail) {
      this.email = this.myEmail;
      this.setMyEmail('');
    }
    if (this.appStatus === AppStatus.ResetPasswordRequired) {
      this.message.type = MessageType.Error;
      this.message.text = this.$t('message.reset_password_required');
    }
  },
  methods: {
    ...mapActions(['setMyEmail', 'setAppStatus', 'startLoading', 'endLoading']),

    async handleForgotPassword () {
      try {
        this.startLoading();
        await forgotPassword(this.email.toLowerCase());
        this.message.type = MessageType.Success;
        this.message.text = this.$t('message.forgot_password_success', { email: this.email.toLowerCase() });
        this.forgotPasswordSuccess = true;
      } catch (error: any) {
        this.message.type = MessageType.Error;
        if (error.code === CognitoException.LimitExceededException) {
          this.message.text = this.$t('message.forgot_password_error');
        } else if (error.code === CognitoException.UserNotFoundException) {
          this.message.text = this.$t('message.forgot_password_try_social');
        } else {
          this.message.text = this.$t('message.forgot_password_generic_error');
        }
      } finally {
        this.endLoading();
        this.email = '';
      }
    },
    switchToLoginPanel (): void {
      this.$router.push({
        path: 'login',
        query: {
          ...this.$route.query
        }
      });
    }
  },
  computed: {
    ...mapGetters([
      'global',
      'forgotPasswordMessages',
      'myEmail',
      'appStatus'
    ]),
    checkEmailError (): boolean {
      return this.email ? !InputValidator.validateEmail(this.email) : false;
    },
    enableSignInButton (): boolean {
      return InputValidator.validateEmail(this.email);
    }
  }
});
